import { DotsVerticalIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { DropdownMenu } from '@/components/shared/dropdown-menu';
import type { DropdownMenuProps } from '@/components/shared/dropdown-menu';

interface CollectionEditDropdownProps {
  onEditCollection: () => void;
}

export function CollectionEditDropdown({
  onEditCollection,
}: CollectionEditDropdownProps) {
  const dropdownMenuItems: DropdownMenuProps['items'] = [
    {
      label: 'Edit Collection name',
      onClick: onEditCollection,
    },
  ];

  return (
    <DropdownMenu items={dropdownMenuItems} align="end">
      <DropdownMenu.Trigger>
        <IconButton
          variant="ghost"
          size="1"
          aria-label="Edit collection"
        >
          <DotsVerticalIcon width={16} height={16} />
        </IconButton>
      </DropdownMenu.Trigger>
    </DropdownMenu>
  );
}

